import PropTypes from 'prop-types';
import { styled } from 'styled-components';

const Body = styled.div`
  background-color: #f8f8f8;
  display: block;
  width: 100%;
  height: 100%;
  padding: 1rem;
`;

const Wrapper = styled.div`
  width: 90%;
  text-align: center;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: sans-serif;

  @media screen and (width >= 480px) {
    width: 480px;
    padding: 3rem 1rem;
  }
`;
const Title = styled.h1`
  color: #b1abab;
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 90px;
  line-height: 0.9;
  letter-spacing: 2px;
`;

const Subtitle = styled.h3`
  color: #b1abab;
  margin-bottom: 0;
  font-size: 36px;
  line-height: 40px;
  letter-spacing: 0.5px;
  margin-top: 15px;
`;

const Main = styled.p`
  color: #f8f8f8;
  font-size: 20px;
  line-height: 26px;
  padding: 0 0 15px;

  @media screen and (width <= 320px) {
    font-size: 18px;
  }

  @media screen and (width >= 480px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

const Text = styled.p`
  color: #f8f8f8;
  font-size: 18px;
  line-height: 22px;
  margin: 15px 0;

  @media screen and (width <= 320px) {
    font-size: 16px;
  }

  @media screen and (width >= 480px) {
    font-size: 20px;
    line-height: 26px;
  }
`;

const TextWrapper = styled.div`
  background-color: #b1abab;
  border-radius: 15px;
  padding: 15px;
  position: relative;
  top: 30px;

  @media screen and (width >= 480px) {
    font-size: 20px;
    line-height: 26px;
    padding: 30px;
  }
`;

const Code = styled.span`
  display: block;
  color: #b1abab;
  margin-top: 15px;
  margin-bottom: 0;
  font-size: 20px;
`;

const information = {
  errorPageData: {
    title: 500,
    code: 'SA-001',
    subtitle: 'Page Data Error',
    main: 'Error requesting data',
    explain: 'Failed to request pageData from API, check the request URL',
  },
  errorPageRender: {
    title: 500,
    code: 'CS-001',
    subtitle: 'Page Render Error',
    main: 'Error rendering the page ',
    explain: 'Failed to render page, ComponentSwitch had no data passed to render components',
  },
  errorStream: {
    title: 500,
    code: 'SSR-001',
    subtitle: 'SSR Error',
    main: 'Error in SSR',
    explain: 'Error thrown in the FE application, while Server Side Rendering app',
  },
  errorStreamDocument: {
    title: 500,
    code: 'SSR-002',
    subtitle: 'NodeStream Error',
    main: 'Error in SSR while streaming app',
    explain:
      'Error thrown in the FE application has caused the head NodeStream to error, check console for errors, this can be caused by incorrect data being passed to components',
  },
  error500: {
    title: 500,
    subtitle: 'Internal Server Error',
    main: 'Sorry for the inconvenience something went wrong',
    explain: 'Please try refreshing the page. If error persists please try again in 30 minutes',
  },
  error: {
    title: 'Error',
    subtitle: 'Internal Server Error',
    main: 'Sorry for the inconvenience something went wrong',
    explain: 'Please try refreshing the page. If error persists please try again in 30 minutes',
  },
};

const ErrorPage = ({ type = 'error' }) => {
  const info = information[type];

  return (
    <Body>
      <Wrapper>
        <Title>{info.title}</Title>
        <Subtitle>{info.subtitle}</Subtitle>
        {info && info.code && <Code>{info.code}</Code>}
        <TextWrapper>
          <Main>{info.main}</Main>
          <Text>{info.explain}</Text>
        </TextWrapper>
      </Wrapper>
    </Body>
  );
};

export default ErrorPage;

ErrorPage.propTypes = {
  type: PropTypes.string,
};
